import mnogoLososya from './icons/mnogo-lososya.svg';
import x5Tech from './icons/x5-tech.svg';
import x5Post from './icons/x5-post.svg';
import x5Media from './icons/x5-media.svg';
import x5Digital from './icons/x5-digital.svg';
import tsPerekrestok from './icons/ts-perekrestok.svg';
import tsPyaterochka from './icons/ts-pyaterochka.svg';
import tsChizhik from './icons/ts-chizhik.svg';
import beTransport from './icons/be-transport.svg';
import beImport from './icons/be-import.svg';
import beFood from './icons/be-food.svg';
import yk from './icons/yk.svg';
import pb from './icons/pb.svg';
import x5ClientExp from './icons/x5-client-exp.svg';

export const Logos: Record<string, string> = {
  '08': '',
  '07': beImport,
  '06': x5Post,
  '05': yk,
  '19': yk,
  '21': yk,
  '04': beTransport,
  '02': tsPerekrestok,
  '01': tsPyaterochka,
  '20': mnogoLososya,
  '18': pb,
  '17': pb,
  '16': pb,
  '14': x5Media,
  '13': tsChizhik,
  '12': x5Digital,
  '11': beFood,
  '10': x5Tech,
  '23': x5ClientExp,
};
